module.exports = require('./lib/KeyCode');
